import { LIST_PLANS_ACTIVE_CHECKOUT_ACTIONS, LIST_PLUS_PLANS, newLimitPlan } from '@/constants';
import { LIST_SHOP_CUSTOM_ENABLE_CHECKOUT } from '@/constants/custom-shop-name';
import { Plan } from '@/constants/enum';
import { dataSettingsSelector, shopInfoSelector } from '@/redux/slice/settings.slice';
import { useSelector } from 'react-redux';

const useUserPlan = () => {
  const dataSettings = useSelector(dataSettingsSelector);
  const shopInfo = useSelector(shopInfoSelector);
  const isPlusTrial = shopInfo.shopifyPlanName === 'Plus Trial';
  const isShopEnableCheckout = LIST_SHOP_CUSTOM_ENABLE_CHECKOUT?.includes(shopInfo.shop);
  const isEnableCheckout = isShopEnableCheckout || dataSettings.plan === Plan.SHOPIFY_PLUS || isPlusTrial;
  const planKey: 'free' | 'standard' = dataSettings.plan === Plan.FREE ? 'free' : 'standard';
  const isPlanLimited = dataSettings.plan === Plan.FREE || dataSettings.plan === Plan.STANDARD;
  const isFreePlan = dataSettings.plan === Plan.FREE;
  const isStandardPlan = dataSettings.plan === Plan.STANDARD;
  const isActivePlusPlan = LIST_PLANS_ACTIVE_CHECKOUT_ACTIONS.includes(shopInfo.shopifyPlan) || isPlusTrial;
  const isShopifyPlus = LIST_PLUS_PLANS.includes(shopInfo.shopifyPlan) || isPlusTrial;

  const limitPlan = [Plan.FREE, Plan.STANDARD].includes(dataSettings.plan)
    ? newLimitPlan[dataSettings.plan as Plan.FREE | Plan.STANDARD]
    : undefined;
  const currentPlan = dataSettings.plan;

  return {
    planKey,
    isPlanLimited,
    isEnableCheckout,
    limitPlan,
    currentPlan,
    isFreePlan,
    isStandardPlan,
    isActivePlusPlan,
    isShopifyPlus,
  };
};

export default useUserPlan;
